import { createElement } from "react";
import type { RouteObject } from "react-router";
import RootRoute from "./RootRoute";
import RouteErrorFallback from "./RouteErrorFallback";
import LegacyRoutes from "./routes";
import SubPageLoading from "views/pages/SubPageLoading";

export const appRoutes = [
  {
    path: "/",
    element: createElement(RootRoute),
    errorElement: createElement(RouteErrorFallback),
    children: [
      {
        index: true,
        element: createElement(LegacyRoutes)
      },
      {
        path: "login",
        hydrateFallbackElement: createElement(SubPageLoading as any, {
          height: "100vh"
        }),
        lazy: () => import("pages/auth/login/route")
      },
      {
        path: "*",
        element: createElement(LegacyRoutes)
      }
    ]
  }
] satisfies RouteObject[];
